export const isLocationValid = location =>
    location instanceof Object &&
    !!location.countryName &&
    !isNaN(location.latitude) &&
    !isNaN(location.longitude);
